<div>
  Roles and Users with access
</div>

<ul class="items-container">
  <li *ngFor="let item of dialogField?.value">
    <div class="item">
      <div class="flex flex-row flex-wrap items-center justify-start avatar-container">
        <ngx-stored-gravatar
          [name]="item.text"
          [email]="'sample'"
          [style]="defaultStyle"
          [hideOnlineStatus]="true"
        >
        </ngx-stored-gravatar>

        <div class="flex  flex-col items-start justify-start content">
          <div>{{item?.text}}</div>
          <div class="tag">{{item?.instruction}}</div>
        </div>
      </div>
      <button [disabled]="IsRemoveButtonDisabled(item)" mat-button type="delete" (click)="onRemoveUserOrRole(item)">Remove</button>
    </div>
  </li>
</ul>
